import { Patient } from './patient-profile-form.state';

export class GetPatientProfileById {
  static readonly type = '[Patient form] Get patient by id';

  constructor(public id: string) {}
}

export class SavePatientProfile {
  static readonly type = '[Patient form] Save patient by id';

  constructor(
    public id: string,
    public patient: Patient,
  ) {}
}

export class ChangeMCOPatientProfile {
  static readonly type = '[Patient form] Change patient MCO';

  constructor(
    public id: string,
    public mcoId: string | number,
  ) {}
}

export class GoToProfilePopUp {
  static readonly type = '[Patient profile] Error messages';

  constructor(
    public id: string,
    public messages: string | number,
  ) {}
}

export class GetRaces {
  static readonly type = '[Patient profile] Get races';
}

export class GetEthnicity {
  static readonly type = '[Patient profile] Get ethnicity';
}
